export function isEmpty(value: any) {

  if (value === null || value === undefined || value === '') {
    return true
  }

  return false

}
